import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

import auth from "./modules/auth";
import masterdata from "./modules/masterdata";
import module from "./modules/module";
import tryout from "./modules/tryout";
import subscribe from "./modules/subscribe";
import coupon from "./modules/coupon";
import testimonial from "./modules/testimonial";
import page from "./modules/page";
import faq from "./modules/faq";
import notif from "./modules/notif";
import classroom from "./modules/classroom";
import user from "./modules/user";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    pageTitle: ""
  },
  getters,
  mutations,
  actions,
  modules: {
    auth,
    masterdata,
    module,
    tryout,
    subscribe,
    coupon,
    testimonial, 
    page, 
    faq, 
    notif, 
    classroom,
    user
  },
  plugins: [createPersistedState()]
});
